// extracted by mini-css-extract-plugin
module.exports = {"squareOne":"dashboard_squareOne__2E75J","menuGridContainer":"dashboard_menuGridContainer__1pHvJ"};